export enum SectionTitles {
  YellowFlags = 'Yellow flags',
  ProvocativeFactors = 'Provocative factors',
  PalliativeFactors = 'Palliative factors',
  Quality = 'Quality',
  Onset = 'Onset',
  AdditionalInformation = 'Additional information',
  Timing = 'Timing',
  AutoAccidentDetails = 'Auto accident details',
  WorkInjuryDetails = 'Work injury details',
  Severity = 'Severity',
  GeneralQuestions = 'General questions',
  SymptomSpecifics = 'Symptom specifics',
  Status = 'Status',
  // Re-eval/extended titles
  Overview = 'Overview',
  AdditionalConcerns = 'Additional Concerns',
  NewProblems = 'New Problems',
  SymptomChanges = 'Symptom Changes',
  History = 'History',
  AutoAccidentDetailsTitleCase = 'Auto Accident Details',
  WorkInjuryDetailsTitleCase = 'Work Injury Details',
  LegalInformation = 'Legal Information',
  Sleep = 'Sleep',
  PsychosocialFactors = 'Psychosocial Factors',
  GeneralHealth = 'General Health',
  AdditionalInformationTitleCase = 'Additional Information',
}

const arrayOfSectionTitles = Object.values(SectionTitles);
